import { useState } from 'react'
import { useCurrentUser, copyToClipboard } from '@dogdisk/shared'
import { AppLayout } from '../components/app-layout'
import { MobileScreen, TopBar } from '../components/mobile-screen'
import { InviteRulesModal } from '../components/modals/invite-rules-modal'

export function InvitePage() {
  const { user } = useCurrentUser()
  const [copied, setCopied] = useState(false)
  // D6 yW9sl 邀请奖励规则 modal 控制
  const [rulesOpen, setRulesOpen] = useState(false)

  if (!user) return null

  const origin = typeof window !== 'undefined' ? window.location.origin : ''
  const link = `${origin}/#/i/${user.user_id}`

  const onCopy = async () => {
    const ok = await copyToClipboard(link)
    if (!ok) return
    setCopied(true)
    setTimeout(() => setCopied(false), 1500)
  }

  const onShare = async () => {
    try {
      const nav = navigator as Navigator & { share?: (data: ShareData) => Promise<void> }
      if (typeof nav.share === 'function') {
        await nav.share({ title: '绅士网盘', text: '一起使用 绅士网盘', url: link })
      } else {
        await onCopy()
      }
    } catch {
      /* cancelled */
    }
  }

  return (
    <AppLayout>
      <MobileScreen>
        <TopBar title="邀请好友" />

        <main data-frame-id="UlwH9" data-testid="UlwH9" className="flex flex-1 flex-col gap-5 px-6 pt-3 pb-32">
          <section className="rounded-2xl bg-gradient-to-br from-[#19caad] via-[#22b9ad] to-[#1d9be0] p-6 text-center text-white shadow-[0_12px_32px_rgba(25,202,173,0.25)]">
            <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/20 text-[18px]">👑</span>
            <p className="mt-3 text-[16px] font-semibold">邀请好友，赢取VIP</p>
          </section>

          <section>
            <p className="mb-2 text-[13px] font-semibold text-[#1A1A1A]">我的推广链接</p>
            <div className="flex items-center gap-2 rounded-lg bg-[#F6F7F8] px-3 py-2">
              <span className="flex-1 truncate font-mono text-[12px] text-[#1A1A1A]">{link}</span>
              <button
                type="button"
                onClick={onCopy}
                className="rounded-md bg-[#19caad] px-3 py-1 text-[12px] font-semibold text-white"
              >
                {copied ? '已复制' : '复制'}
              </button>
            </div>
          </section>

          <section className="flex flex-col items-center gap-3 rounded-2xl bg-[#F6F7F8] p-6">
            <div className="flex h-40 w-40 items-center justify-center rounded-2xl bg-white">
              <span className="flex h-20 w-20 items-center justify-center rounded-2xl bg-[#a8e9d8] text-[#0f7969]">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V7z" /></svg>
              </span>
            </div>
            <p className="text-[12px] text-[#9CA3AF]">扫一扫即可注册</p>
            <button
              type="button"
              onClick={onShare}
              className="flex items-center gap-2 rounded-lg bg-white px-4 py-2 text-[13px] text-[#1A1A1A]"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 4v12M5 11l7 7 7-7" /></svg>
              保存图片
            </button>
          </section>

          <section>
            <div className="mb-2 flex items-center gap-2">
              <p className="text-[13px] font-semibold text-[#1A1A1A]">奖励规则</p>
              {/* D6 yW9sl 触发器:? icon 弹规则详细 modal */}
              <button
                type="button"
                data-testid="UlwH9-rules-help"
                aria-label="查看奖励规则详情"
                onClick={() => setRulesOpen(true)}
                className="flex h-5 w-5 items-center justify-center rounded-full bg-[#F6F7F8] text-[11px] font-semibold text-[#9CA3AF] hover:bg-[#E5E7EB]"
              >
                ?
              </button>
            </div>
            <ul className="flex flex-col gap-2 rounded-2xl bg-[#F6F7F8] p-4 text-[13px]">
              <li className="flex justify-between">
                <span className="text-[#1A1A1A]">邀请注册奖励</span>
                <span className="font-semibold text-[#19caad]">+1天VIP</span>
              </li>
              <li className="flex justify-between">
                <span className="text-[#1A1A1A]">好友购买 VIP 奖励</span>
                <span className="font-semibold text-[#19caad]">+7天VIP</span>
              </li>
              <li className="flex justify-between">
                <span className="text-[#1A1A1A]">无上限叠加</span>
                <span className="text-[#9CA3AF]">续费 / 升级 重复触发</span>
              </li>
            </ul>
          </section>
        </main>
      </MobileScreen>

      <InviteRulesModal open={rulesOpen} onClose={() => setRulesOpen(false)} />
    </AppLayout>
  )
}
